import { MESSAGE_TYPE } from '@/constants/message';
import axios from 'axios';
import moment from 'moment';
import BaseService from '@/api/services/BaseService';

let searchCancelToken = null;

export default class MessageService extends BaseService {

  /**
   *  POST sms/messages/sms/:from/send
   **/
  static sendSMS({ from, to, toList, body, originationTime, groupMessage = false }) {
    const type = MESSAGE_TYPE.sms.toLowerCase();
    const URI = `${type}/messages/${type}/${encodeURIComponent(from)}/send`;

    return this.postRequest(URI, { from, to, toList, body, originationTime, groupMessage });
  }

  /**
   *  POST mms/messages/mms/:from/send
   **/
  static sendMMS(formData) {
    const type = MESSAGE_TYPE.mms.toLowerCase();
    const URI = `${type}/messages/${type}/${this.encodedUserNumber}/send`;
    const config = { headers: { 'Content-Type': 'multipart/form-data' } };

    return this.postRequest(URI, formData, config);
  }

  /**
   *  POST sms/messages/:from/:size/preview
   **/
  static getMessagePreview({ body }, size = 250) {
    const URI = `sms/messages/${this.encodedUserNumber}/${size}/preview`;
    return this.postRequest(URI, { body });
  }

  /**
   *  POST sms/messages/sms/:from/send/group
   **/
  static sendGroupContactMessage(id, { body, messageType }) {
    const type = (messageType || MESSAGE_TYPE.sms).toLowerCase();
    const URI = `${type}/messages/${type}/${this.encodedUserNumber}/send/group`;

    return this.postRequest(URI, { to: id, body });
  }

  /**
   *  GET sms/attachments/:attachmentsId
   **/
  static getAttachments(attachmentsId) {
    return this.getRequest(`sms/attachments/${encodeURIComponent(attachmentsId)}`);
  }

  /**
   *  GET sms/messages/contain/:userId/:since/:searchStr
   **/
  static search(searchStr, monthsAgo = 12) {
    if (searchCancelToken) MessageService.stopStaticSearch();
    searchCancelToken = axios.CancelToken.source();

    const since = moment().subtract(monthsAgo, 'months').format(this.apiDateTimeFormat);
    const URI = `sms/messages/contain/${this.encodedUserId}/${encodeURI(since)}/${encodeURI(searchStr)}`;
    const config = {
      cancelToken: searchCancelToken.token,
      headers: {
        'exclude-attachments': true,
        'result-limit': 100
      }
    };

    return this.getRequest(URI, config);
  }

  static stopStaticSearch() {
    if (searchCancelToken) searchCancelToken.cancel('Active search stopped.');
  }

  /**
   *  GET sms/messages/:userId/:fromDate/:toDate
   **/
  static getMessagesByDateRange(from, to) {
    const fromDate = moment(from).utc().format(BaseService.apiDateTimeFormat);
    const toDate = moment(to).utc().format(BaseService.apiDateTimeFormat);
    const messagesUrl = `sms/messages/${this.encodedUserId}/${fromDate}/${toDate}`;

    const config = {
      headers: {
        'exclude-attachments': true
      }
    };

    return this.getRequest(messagesUrl, config);
  }

  /**
   *  DELETE message by row id.
   **/
  static deleteMessageByRowId(rowId, markAsDeleted = false) {
    const messagesUrl = `sms/messages/rowId/${rowId}?markAsDeleted=${markAsDeleted}`;

    const config = {
      headers: {
        'exclude-attachments': true
      }
    };

    return this.deleteRequestWithFullResponse(messagesUrl, config);
  }
}
